"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8650],{

/***/ 85740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ campaignMap; }
/* harmony export */ });
/**
 * id: The campaign id (required)
 * type: The type of the achievement
 * title: A string or an object to be translated.
 * Note: If the value is a string it is likely used as data in a translation object
 *
 * badge: Achievement avatar
 */ var campaigns = [
    {
        id: "511110000",
        type: "ifo",
        title: "Kalmar",
        badge: "ifo-kalm.svg"
    },
    {
        id: "511100000",
        type: "ifo",
        title: "Hotcross",
        badge: "ifo-hotcross.svg"
    },
    {
        id: "511090000",
        type: "ifo",
        title: "Horizon Protocol",
        badge: "ifo-hzn.svg"
    },
    {
        id: "511080000",
        type: "ifo",
        title: "Belt",
        badge: "ifo-belt.svg"
    },
    {
        id: "511070000",
        type: "ifo",
        title: "Yieldwatch",
        badge: "ifo-watch.svg"
    },
    {
        id: "511060000",
        type: "ifo",
        title: "Berry",
        badge: "ifo-bry.svg"
    },
    {
        id: "511050000",
        type: "ifo",
        title: "Soteria",
        badge: "ifo-wsote.svg"
    },
    {
        id: "511040000",
        type: "ifo",
        title: "Helmet",
        badge: "ifo-helmet.svg"
    },
    {
        id: "511030000",
        type: "ifo",
        title: "Tenet",
        badge: "ifo-ten.svg"
    },
    {
        id: "511020000",
        type: "ifo",
        title: "Ditto",
        badge: "ifo-ditto.svg"
    },
    {
        id: "511010000",
        type: "ifo",
        title: "Blink",
        badge: "ifo-blink.svg"
    },
    {
        id: "512010001",
        type: "teambattle",
        title: "Easter Champion: Gold",
        badge: "easter-champion-gold.svg"
    },
    {
        id: "512010002",
        type: "teambattle",
        title: "Easter Top 500: Gold",
        badge: "easter-top-500-gold.svg"
    },
    {
        id: "512010003",
        type: "teambattle",
        title: "Easter Top 500: Gold",
        badge: "easter-top-500-gold.svg"
    },
    {
        id: "512010004",
        type: "teambattle",
        title: "Easter Top 500: Gold",
        badge: "easter-top-500-gold.svg"
    },
    {
        id: "512010005",
        type: "teambattle",
        title: "Easter Participant: Gold",
        badge: "easter-participant-gold.svg"
    },
    {
        id: "512010006",
        type: "teambattle",
        title: "Easter Champion: Silver",
        badge: "easter-champion-silver.svg"
    },
    {
        id: "512010007",
        type: "teambattle",
        title: "Easter Top 500: Silver",
        badge: "easter-top-500-silver.svg"
    },
    {
        id: "512010008",
        type: "teambattle",
        title: "Easter Top 500: Silver",
        badge: "easter-top-500-silver.svg"
    },
    {
        id: "512010009",
        type: "teambattle",
        title: "Easter Top 500: Silver",
        badge: "easter-top-500-silver.svg"
    },
    {
        id: "512010010",
        type: "teambattle",
        title: "Easter Participant: Silver",
        badge: "easter-participant-silver.svg"
    },
    {
        id: "512010011",
        type: "teambattle",
        title: "Easter Champion: Bronze",
        badge: "easter-champion-bronze.svg"
    },
    {
        id: "512010012",
        type: "teambattle",
        title: "Easter Top 500: Bronze",
        badge: "easter-top-500-bronze.svg"
    },
    {
        id: "512010013",
        type: "teambattle",
        title: "Easter Top 500: Bronze",
        badge: "easter-top-500-bronze.svg"
    },
    {
        id: "512010014",
        type: "teambattle",
        title: "Easter Top 500: Bronze",
        badge: "easter-top-500-bronze.svg"
    },
    {
        id: "512010015",
        type: "teambattle",
        title: "Easter Participant: Bronze",
        badge: "easter-participant-bronze.svg"
    },
    {
        id: "513010001",
        type: "participation",
        title: "Syrup Soaker",
        description: "Took a dip in the early days of the Auto CAKE Pool",
        badge: "syrup-soaker.svg"
    },
    {
        id: "514010001",
        type: "participation",
        title: "Clairvoyant",
        description: "Played a round of Prediction before round 12,120",
        badge: "clairvoyant.svg"
    },
    {
        id: "515010001",
        type: "participation",
        title: "Lottie",
        description: "Joined a round in the early days of Lottery V2",
        badge: "lottie.svg"
    },
    {
        id: "515020001",
        type: "participation",
        title: "Lucky",
        description: "Won a round in the early days of Lottery V2",
        badge: "lucky.svg"
    },
    {
        id: "515030001",
        type: "participation",
        title: "Baller",
        description: "Top 100 ticket buyer in the early days of Lottery V2",
        badge: "baller.svg"
    },
    {
        id: "516010001",
        type: "participation",
        title: "1 Year",
        description: "Joined PancakeSwap during the first year of our journey!",
        badge: "1-year.svg"
    },
    {
        id: "511120000",
        type: "ifo",
        title: "Duelist King",
        badge: "ifo-dkt.svg"
    },
    {
        id: "511130000",
        type: "ifo",
        title: "Mines of Dalarnia",
        badge: "ifo-dar.svg"
    },
    {
        id: "511140000",
        type: "ifo",
        title: "FC Porto Fan Token",
        badge: "ifo-porto.svg"
    },
    {
        id: "511150000",
        type: "ifo",
        title: "FC Santos Fan Token",
        badge: "ifo-santos.svg"
    },
    {
        id: "512020001",
        type: "teambattle",
        title: "Fan Token Champion: Gold",
        badge: "fan-token-champion-gold.svg"
    },
    {
        id: "512020002",
        type: "teambattle",
        title: "Fan Token Top 10: Gold",
        badge: "fan-token-top-10-gold.svg"
    },
    {
        id: "512020003",
        type: "teambattle",
        title: "Fan Token Top 100: Gold",
        badge: "fan-token-top-100-gold.svg"
    },
    {
        id: "512020004",
        type: "teambattle",
        title: "Fan Token Top 500: Gold",
        badge: "fan-token-top-500-gold.svg"
    },
    {
        id: "512020005",
        type: "teambattle",
        title: "Fan Token Participant: Gold",
        badge: "fan-token-participant-gold.svg"
    },
    {
        id: "512020006",
        type: "teambattle",
        title: "Fan Token Champion: Silver",
        badge: "fan-token-champion-silver.svg"
    },
    {
        id: "512020007",
        type: "teambattle",
        title: "Fan Token Top 10: Silver",
        badge: "fan-token-top-10-silver.svg"
    },
    {
        id: "512020008",
        type: "teambattle",
        title: "Fan Token Top 100: Silver",
        badge: "fan-token-top-100-silver.svg"
    },
    {
        id: "512020009",
        type: "teambattle",
        title: "Fan Token Top 500: Silver",
        badge: "fan-token-top-500-silver.svg"
    },
    {
        id: "512020010",
        type: "teambattle",
        title: "Fan Token Participant: Silver",
        badge: "fan-token-participant-silver.svg"
    },
    {
        id: "512020011",
        type: "teambattle",
        title: "Fan Token Champion: Bronze",
        badge: "fan-token-champion-bronze.svg"
    },
    {
        id: "512020012",
        type: "teambattle",
        title: "Fan Token Top 10: Bronze",
        badge: "fan-token-top-10-bronze.svg"
    },
    {
        id: "512020013",
        type: "teambattle",
        title: "Fan Token Top 100: Bronze",
        badge: "fan-token-top-100-bronze.svg"
    },
    {
        id: "512020014",
        type: "teambattle",
        title: "Fan Token Top 500: Bronze",
        badge: "fan-token-top-500-bronze.svg"
    },
    {
        id: "512020015",
        type: "teambattle",
        title: "Fan Token Participant: Bronze",
        badge: "fan-token-participant-bronze.svg"
    },
    {
        id: "511160000",
        type: "ifo",
        title: "Diviner Protocol",
        badge: "ifo-dpt.svg"
    },
    {
        id: "511170000",
        type: "ifo",
        title: "Froyo Games",
        badge: "ifo-froyo.svg"
    },
    {
        id: "511180000",
        type: "ifo",
        title: "Era7",
        badge: "ifo-era.svg"
    },
    {
        id: "511190000",
        type: "ifo",
        title: "Duet",
        badge: "ifo-duet.svg"
    },
    {
        id: "511200000",
        type: "ifo",
        title: "Trivia",
        badge: "ifo-trivia.svg"
    },
    {
        id: "511300000",
        type: "ifo",
        title: "Peel",
        badge: "ifo-peel.svg"
    },
    {
        id: "511400000",
        type: "ifo",
        title: "Wom",
        badge: "ifo-wom.svg"
    },
    {
        id: "512030001",
        type: "teambattle",
        title: "Mobox Champion: Gold",
        badge: "MBOX-champion-gold.svg"
    },
    {
        id: "512030002",
        type: "teambattle",
        title: "Mobox Top 10: Gold",
        badge: "MBOX-top-10-gold.svg"
    },
    {
        id: "512030003",
        type: "teambattle",
        title: "Mobox Top 100: Gold",
        badge: "MBOX-top-100-gold.svg"
    },
    {
        id: "512030004",
        type: "teambattle",
        title: "Mobox Top 500: Gold",
        badge: "MBOX-top-500-gold.svg"
    },
    {
        id: "512030005",
        type: "teambattle",
        title: "Mobox Participant: Gold",
        badge: "MBOX-participant-gold.svg"
    },
    {
        id: "512030006",
        type: "teambattle",
        title: "Mobox Champion: Silver",
        badge: "MBOX-champion-silver.svg"
    },
    {
        id: "512030007",
        type: "teambattle",
        title: "Mobox Top 10: Silver",
        badge: "MBOX-top-10-silver.svg"
    },
    {
        id: "512030008",
        type: "teambattle",
        title: "Mobox Top 100: Silver",
        badge: "MBOX-top-100-silver.svg"
    },
    {
        id: "512030009",
        type: "teambattle",
        title: "Mobox Top 500: Silver",
        badge: "MBOX-top-500-silver.svg"
    },
    {
        id: "512030010",
        type: "teambattle",
        title: "Mobox Participant: Silver",
        badge: "MBOX-participant-silver.svg"
    },
    {
        id: "512030011",
        type: "teambattle",
        title: "Mobox Champion: Bronze",
        badge: "MBOX-champion-bronze.svg"
    },
    {
        id: "512030012",
        type: "teambattle",
        title: "Mobox Top 10: Bronze",
        badge: "MBOX-top-10-bronze.svg"
    },
    {
        id: "512030013",
        type: "teambattle",
        title: "Mobox Top 100: Bronze",
        badge: "MBOX-top-100-bronze.svg"
    },
    {
        id: "512030014",
        type: "teambattle",
        title: "Mobox Top 500: Bronze",
        badge: "MBOX-top-500-bronze.svg"
    },
    {
        id: "512030015",
        type: "teambattle",
        title: "Mobox Participant: Bronze",
        badge: "MBOX-participant-bronze.svg"
    },
    {
        id: "512040001",
        type: "teambattle",
        title: "MoD Champion: Gold",
        badge: "MoD-champion-gold.svg"
    },
    {
        id: "512040002",
        type: "teambattle",
        title: "MoD Top 10: Gold",
        badge: "MoD-top-10-gold.svg"
    },
    {
        id: "512040003",
        type: "teambattle",
        title: "MoD Top 100: Gold",
        badge: "MoD-top-100-gold.svg"
    },
    {
        id: "512040004",
        type: "teambattle",
        title: "MoD Top 500: Gold",
        badge: "MoD-top-500-gold.svg"
    },
    {
        id: "512040005",
        type: "teambattle",
        title: "MoD Participant: Gold",
        badge: "MoD-participant-gold.svg"
    },
    {
        id: "512040006",
        type: "teambattle",
        title: "MoD Champion: Silver",
        badge: "MoD-champion-silver.svg"
    },
    {
        id: "512040007",
        type: "teambattle",
        title: "MoD Top 10: Silver",
        badge: "MoD-top-10-silver.svg"
    },
    {
        id: "512040008",
        type: "teambattle",
        title: "MoD Top 100: Silver",
        badge: "MoD-top-100-silver.svg"
    },
    {
        id: "512040009",
        type: "teambattle",
        title: "MoD Top 500: Silver",
        badge: "MoD-top-500-silver.svg"
    },
    {
        id: "512040010",
        type: "teambattle",
        title: "MoD Participant: Silver",
        badge: "MoD-participant-silver.svg"
    },
    {
        id: "512040011",
        type: "teambattle",
        title: "MoD Champion: Bronze",
        badge: "MoD-champion-bronze.svg"
    },
    {
        id: "512040012",
        type: "teambattle",
        title: "MoD Top 10: Bronze",
        badge: "MoD-top-10-bronze.svg"
    },
    {
        id: "512040013",
        type: "teambattle",
        title: "MoD Top 100: Bronze",
        badge: "MoD-top-100-bronze.svg"
    },
    {
        id: "512040014",
        type: "teambattle",
        title: "MoD Top 500: Bronze",
        badge: "MoD-top-500-bronze.svg"
    },
    {
        id: "512040015",
        type: "teambattle",
        title: "MoD Participant: Bronze",
        badge: "MoD-participant-bronze.svg"
    }, 
];
/**
 * Transform the campaign config into a map. Keeps the config the same
 * as the others and allows easy access to a campaign by id
 */ var campaignMap = new Map();
campaigns.forEach(function(campaign) {
    campaignMap.set(campaign.id, campaign);
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (campaigns)));


/***/ }),

/***/ 48650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$v": function() { return /* binding */ useAchievementsForAddress; },
  "Un": function() { return /* binding */ useProfile; },
  "lC": function() { return /* binding */ useProfileForAddress; }
});

// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46587);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/config/constants/campaigns.ts
var campaigns = __webpack_require__(85740);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./src/utils/achievements.ts
var achievements = __webpack_require__(5107);
;// CONCATENATED MODULE: ./src/state/achievements/helpers.ts




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getUserPointIncreaseEvents($account: ID!) {\n          user(id: $account) {\n            points {\n              id\n              campaignId\n              points\n            }\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 * Gets all user point increase events on the profile filtered by wallet address
 */ var getUserPointIncreaseEvents = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account) {
        var user, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_PROFILE */.YP, (0,dist.gql)(_templateObject()), {
                            account: account.toLowerCase()
                        })
                    ];
                case 1:
                    user = _state.sent().user;
                    return [
                        2,
                        user.points
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserPointIncreaseEvents(account) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Gets all user point increase events and adds achievement meta
 */ var getAchievements = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account) {
        var pointIncreaseEvents;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getUserPointIncreaseEvents(account)
                    ];
                case 1:
                    pointIncreaseEvents = _state.sent();
                    if (!pointIncreaseEvents) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        pointIncreaseEvents.reduce(function(accum, userPoint) {
                            if (!campaigns/* campaignMap.has */.T.has(userPoint.campaignId)) {
                                return accum;
                            }
                            var campaignMeta = campaigns/* campaignMap.get */.T.get(userPoint.campaignId);
                            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                                {
                                    id: userPoint.campaignId,
                                    type: campaignMeta.type,
                                    address: userPoint.id,
                                    title: (0,achievements/* getAchievementTitle */.hi)(campaignMeta),
                                    description: (0,achievements/* getAchievementDescription */.A9)(campaignMeta),
                                    badge: campaignMeta.badge,
                                    points: Number(userPoint.points)
                                }, 
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function getAchievements(account) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(97971);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(38472);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./src/config/abi/pancakeProfile.json
var pancakeProfile = __webpack_require__(92335);
// EXTERNAL MODULE: ./src/state/teams/helpers.ts + 1 modules
var helpers = __webpack_require__(50339);
// EXTERNAL MODULE: ./src/state/nftMarket/helpers.ts + 1 modules
var nftMarket_helpers = __webpack_require__(86849);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
;// CONCATENATED MODULE: ./src/state/profile/helpers.ts
/* provided dependency */ var process = __webpack_require__(34155);








var transformProfileResponse = function(profileResponse) {
    var userId = profileResponse[0], numberPoints = profileResponse[1], teamId = profileResponse[2], collectionAddress = profileResponse[3], tokenId = profileResponse[4], isActive = profileResponse[5];
    return {
        userId: userId.toNumber(),
        points: numberPoints.toNumber(),
        teamId: teamId.toNumber(),
        tokenId: tokenId.toNumber(),
        collectionAddress: collectionAddress,
        isActive: isActive
    };
};
var profileApi = process.env.NEXT_PUBLIC_API_PROFILE;
var getUsername = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
        var response, ref, _username, username, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("".concat(profileApi, "/api/users/").concat(address.toLowerCase()))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        return [
                            2,
                            ""
                        ];
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    ref = _state.sent(), _username = ref.username, username = _username === void 0 ? "" : _username;
                    return [
                        2,
                        username
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        ""
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUsername(address) {
        return _ref.apply(this, arguments);
    };
}();
var getProfile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
        var profileCalls, profileCallsResult, _profileCallsResult, ref, hasRegistered, profileResponse, ref1, userId, points, teamId, tokenId, collectionAddress, isActive, ref2, team, username, nftRes, nftToken, ref3, ref4, profile, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    profileCalls = [
                        "hasRegistered",
                        "getUserProfile"
                    ].map(function(method) {
                        return {
                            address: (0,addressHelpers/* getPancakeProfileAddress */.Re)(),
                            name: method,
                            params: [
                                address
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: pancakeProfile,
                            calls: profileCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 1:
                    profileCallsResult = _state.sent();
                    _profileCallsResult = (0,_sliced_to_array/* default */.Z)(profileCallsResult, 2), ref = (0,_sliced_to_array/* default */.Z)(_profileCallsResult[0], 1), hasRegistered = ref[0], profileResponse = _profileCallsResult[1];
                    if (!hasRegistered) {
                        return [
                            2,
                            {
                                hasRegistered: hasRegistered,
                                profile: null
                            }
                        ];
                    }
                    ref1 = transformProfileResponse(profileResponse), userId = ref1.userId, points = ref1.points, teamId = ref1.teamId, tokenId = ref1.tokenId, collectionAddress = ref1.collectionAddress, isActive = ref1.isActive;
                    return [
                        4,
                        Promise.all([
                            (0,helpers/* getTeam */.V)(teamId),
                            getUsername(address),
                            isActive ? (0,nftMarket_helpers/* getNftApi */.hb)(collectionAddress, tokenId.toString()) : Promise.resolve(null)
                        ])
                    ];
                case 2:
                    ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), team = ref2[0], username = ref2[1], nftRes = ref2[2];
                    // If the profile is not active the tokenId returns 0, which is still a valid token id
                    // so only fetch the nft data if active
                    if (nftRes) {
                        ;
                        nftToken = {
                            tokenId: nftRes.tokenId,
                            name: nftRes.name,
                            collectionName: nftRes.collection.name,
                            collectionAddress: collectionAddress,
                            description: nftRes.description,
                            attributes: nftRes.attributes,
                            createdAt: nftRes.createdAt,
                            updatedAt: nftRes.updatedAt,
                            image: {
                                original: (ref3 = nftRes.image) === null || ref3 === void 0 ? void 0 : ref3.original,
                                thumbnail: (ref4 = nftRes.image) === null || ref4 === void 0 ? void 0 : ref4.thumbnail
                            }
                        };
                    }
                    profile = {
                        userId: userId,
                        points: points,
                        teamId: teamId,
                        tokenId: tokenId,
                        username: username,
                        collectionAddress: collectionAddress,
                        isActive: isActive,
                        nft: nftToken,
                        team: team
                    };
                    return [
                        2,
                        {
                            hasRegistered: hasRegistered,
                            profile: profile
                        }
                    ];
                case 3:
                    e = _state.sent();
                    console.error(e);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getProfile(address) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/profile/hooks.ts







var useProfileForAddress = function(address) {
    var fetchConfiguration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        revalidateIfStale: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    };
    var ref = (0,swr_dist/* default */.ZP)(address ? [
        address,
        "profile"
    ] : null, function() {
        return getProfile(address);
    }, fetchConfiguration), data = ref.data, status = ref.status, mutate = ref.mutate, isValidating = ref.isValidating;
    var profile = (data !== null && data !== void 0 ? data : {
        profile: null
    }).profile;
    return {
        profile: profile,
        isFetching: status === types/* FetchStatus.Fetching */.iF.Fetching,
        isValidating: isValidating,
        refresh: mutate
    };
};
var useAchievementsForAddress = function(address) {
    var ref = (0,immutable_dist/* default */.Z)(address ? [
        address,
        "achievements"
    ] : null, function() {
        return getAchievements(address);
    }), data = ref.data, status = ref.status, mutate = ref.mutate;
    return {
        achievements: data || [],
        isFetching: status === types/* FetchStatus.Fetching */.iF.Fetching,
        refresh: mutate
    };
};
var useProfile = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref = (0,immutable_dist/* default */.Z)(account ? [
        account,
        "profile"
    ] : null, function() {
        return getProfile(account);
    }, {
        use: [
            useSWRContract/* localStorageMiddleware */.PI
        ]
    }), data = ref.data, status = ref.status, mutate = ref.mutate;
    var ref1 = data !== null && data !== void 0 ? data : {
        profile: null,
        hasRegistered: false
    }, profile = ref1.profile, hasRegistered = ref1.hasRegistered;
    var isLoading = status === types/* FetchStatus.Fetching */.iF.Fetching;
    var isInitialized = status === types/* FetchStatus.Fetched */.iF.Fetched || status === types/* FetchStatus.Failed */.iF.Failed;
    var hasProfile = isInitialized && hasRegistered;
    var hasActiveProfile = hasProfile && (profile === null || profile === void 0 ? void 0 : profile.isActive);
    return {
        profile: profile,
        hasProfile: hasProfile,
        hasActiveProfile: hasActiveProfile,
        isInitialized: isInitialized,
        isLoading: isLoading,
        refresh: mutate
    };
};


/***/ }),

/***/ 50339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ getTeam; },
  "L": function() { return /* binding */ getTeams; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46587);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(33206);
;// CONCATENATED MODULE: ./src/config/constants/teams.ts

var teams = [
    {
        id: 1,
        name: "Syrup Storm",
        description: "The storm's a-comin! Watch out! These bulls are stampeding in a syrupy surge!",
        images: {
            lg: "syrup-storm-lg.png",
            md: "syrup-storm-md.png",
            sm: "syrup-storm-sm.png",
            alt: "syrup-storm-alt.png",
            ipfs: "".concat(config/* IPFS_GATEWAY */.Gs, "/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/syrup-storm.png")
        },
        background: "syrup-storm-bg.svg",
        textColor: "#191326",
        users: 0,
        points: 0
    },
    {
        id: 2,
        name: "Fearsome Flippers",
        description: "The flippening is coming. Don't get in these bunnies' way, or you'll get flipped, too!",
        images: {
            lg: "fearsome-flippers-lg.png",
            md: "fearsome-flippers-md.png",
            sm: "fearsome-flippers-sm.png",
            alt: "fearsome-flippers-alt.png",
            ipfs: "".concat(config/* IPFS_GATEWAY */.Gs, "/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/fearsome-flippers.png")
        },
        background: "fearsome-flippers-bg.svg",
        textColor: "#FFFFFF",
        users: 0,
        points: 0
    },
    {
        id: 3,
        name: "Chaotic Cakers",
        description: "Can you stand the heat? Stay out of the kitchen or you might get burned to a crisp!",
        images: {
            lg: "chaotic-cakers-lg.png",
            md: "chaotic-cakers-md.png",
            sm: "chaotic-cakers-sm.png",
            alt: "chaotic-cakers-alt.png",
            ipfs: "".concat(config/* IPFS_GATEWAY */.Gs, "/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/chaotic-cakers.png")
        },
        background: "chaotic-cakers-bg.svg",
        textColor: "#191326",
        users: 0,
        points: 0
    }, 
];
/* harmony default export */ var constants_teams = (teams);

// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 25 modules
var contractHelpers = __webpack_require__(97844);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/config/abi/pancakeProfile.json
var pancakeProfile = __webpack_require__(92335);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
;// CONCATENATED MODULE: ./src/state/teams/helpers.ts











var profileContract = (0,contractHelpers/* getProfileContract */.Y4)();
var getTeam = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(teamId) {
        var ref, teamName, numberUsers, numberPoints, isJoinable, staticTeamInfo, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        profileContract.getTeamProfile(teamId)
                    ];
                case 1:
                    ref = _state.sent(), teamName = ref[0], numberUsers = ref[2], numberPoints = ref[3], isJoinable = ref[4];
                    staticTeamInfo = constants_teams.find(function(staticTeam) {
                        return staticTeam.id === teamId;
                    });
                    return [
                        2,
                        merge_default()({}, staticTeamInfo, {
                            isJoinable: isJoinable,
                            name: teamName,
                            users: numberUsers.toNumber(),
                            points: numberPoints.toNumber()
                        })
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTeam(teamId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Gets on-chain data and merges it with the existing static list of teams
 */ var getTeams = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var teamsById, nbTeams, calls, i, teamData, onChainTeamData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    teamsById = constants_teams.reduce(function(accum, team) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, team.id, team));
                    }, {});
                    return [
                        4,
                        profileContract.numberTeams()
                    ];
                case 1:
                    nbTeams = _state.sent();
                    calls = [];
                    for(i = 1; i <= nbTeams.toNumber(); i++){
                        calls.push({
                            address: (0,addressHelpers/* getPancakeProfileAddress */.Re)(),
                            name: "getTeamProfile",
                            params: [
                                i
                            ]
                        });
                    }
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: pancakeProfile,
                            calls: calls
                        })
                    ];
                case 2:
                    teamData = _state.sent();
                    onChainTeamData = teamData.reduce(function(accum, team, index) {
                        var teamName = team[0], numberUsers = team[2], numberPoints = team[3], isJoinable = team[4];
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, index + 1, {
                            name: teamName,
                            users: numberUsers.toNumber(),
                            points: numberPoints.toNumber(),
                            isJoinable: isJoinable
                        }));
                    }, {});
                    return [
                        2,
                        merge_default()({}, teamsById, onChainTeamData)
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTeams() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 5107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ getAchievementDescription; },
/* harmony export */   "Cl": function() { return /* binding */ getClaimableIfoData; },
/* harmony export */   "hi": function() { return /* binding */ getAchievementTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9941);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69779);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46587);
/* harmony import */ var config_constants_ifo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47829);
/* harmony import */ var config_constants_campaigns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85740);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41144);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96273);
/* harmony import */ var config_abi_pointCenterIfo_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58750);









var getAchievementTitle = function(campaign) {
    switch(campaign.type){
        case "ifo":
            return {
                key: "IFO Shopper: %title%",
                data: {
                    title: campaign.title
                }
            };
        default:
            return campaign.title;
    }
};
var getAchievementDescription = function(campaign) {
    switch(campaign.type){
        case "ifo":
            return {
                key: "Committed more than $5 worth of LP in the %title% IFO",
                data: {
                    title: campaign.title
                }
            };
        default:
            return campaign.description;
    }
};
/**
 * Checks if a wallet is eligible to claim points from valid IFO's
 */ var getClaimableIfoData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(account) {
        var ifoCampaigns, claimStatusCalls, claimStatuses, claimableIfoData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ifoCampaigns = config_constants_ifo__WEBPACK_IMPORTED_MODULE_0__/* ["default"].filter */ .Z.filter(function(ifoItem) {
                        return ifoItem.campaignId !== undefined;
                    });
                    claimStatusCalls = ifoCampaigns.map(function(param) {
                        var address = param.address;
                        return {
                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getPointCenterIfoAddress */ .Cf)(),
                            name: "checkClaimStatus",
                            params: [
                                account,
                                address
                            ]
                        };
                    });
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_2__/* .multicallv2 */ .vf)({
                            abi: config_abi_pointCenterIfo_json__WEBPACK_IMPORTED_MODULE_4__,
                            calls: claimStatusCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 1:
                    claimStatuses = _state.sent();
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_2__/* .multicallv2 */ .vf)({
                            abi: config_abi_pointCenterIfo_json__WEBPACK_IMPORTED_MODULE_4__,
                            calls: claimStatuses.reduce(function(accum, claimStatusArr, index) {
                                if (claimStatusArr === null) {
                                    return accum;
                                }
                                var _claimStatusArr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(claimStatusArr, 1), claimStatus = _claimStatusArr[0];
                                if (claimStatus === true) {
                                    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(accum).concat([
                                        {
                                            address: (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getPointCenterIfoAddress */ .Cf)(),
                                            name: "ifos",
                                            params: [
                                                ifoCampaigns[index].address
                                            ]
                                        }
                                    ]);
                                }
                                return accum;
                            }, [])
                        })
                    ];
                case 2:
                    claimableIfoData = _state.sent();
                    // Transform response to an Achievement
                    return [
                        2,
                        claimableIfoData.reduce(function(accum, claimableIfoDataItem) {
                            var claimableCampaignId = claimableIfoDataItem.campaignId.toString();
                            if (!config_constants_campaigns__WEBPACK_IMPORTED_MODULE_1__/* .campaignMap.has */ .T.has(claimableCampaignId)) {
                                return accum;
                            }
                            var campaignMeta = config_constants_campaigns__WEBPACK_IMPORTED_MODULE_1__/* .campaignMap.get */ .T.get(claimableCampaignId);
                            var address = ifoCampaigns.find(function(ifoCampaign) {
                                return ifoCampaign.campaignId === claimableCampaignId;
                            }).address;
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(accum).concat([
                                {
                                    address: address,
                                    id: claimableCampaignId,
                                    type: "ifo",
                                    title: getAchievementTitle(campaignMeta),
                                    description: getAchievementDescription(campaignMeta),
                                    badge: campaignMeta.badge,
                                    points: claimableIfoDataItem.numberPoints.toNumber()
                                }, 
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function getClaimableIfoData(account) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);